<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.permissao"
        ref="DataTable"
        search-by="usuarioNome"
        sort-by="unidadeNomeFantasia"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'administracao-permissao-edit', params: { id: item.id } })"
                color="primary"
                authorize="update-administracao-permissao"
                title="Alterar permissões"
                small
            >
                <rkm-icon icon="key" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository } from '@/mixins'

export default {
    created() {

        this.repositories = {
            permissao: this.getConectaSusRepository('administracao.permissao')
        }
    },
    data: () => ({
        fields: [
            {
                name: 'unidade.nomeFantasia',
                key: 'unidadeNomeFantasia',
                label: 'Unidade',
                searchable: true,
                sortable: true
            },
            {
                name: 'infraestrutura.nome',
                key: 'infraestruturaNome',
                label: 'Local de atendimento',
                searchable: true,
                sortable: true
            },
            {
                name: 'cidadao.nome',
                key: 'usuarioNome',
                label: 'Usuário',
                searchable: true,
                sortable: true
            },
            {
                name: 'ocupacao.nome',
                key: 'ocupacaoNome',
                label: 'CBO',
                searchable: true,
                sortable: true
            },
            {
                name: 'actions',
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
    }),
    mixins: [repository],
}
</script>